
        <!-- <v-flex>
          <v-item v-slot:default="{ active, toggle }">
            <v-card
              :color="active ? 'primary' : ''"
              class="d-flex align-center"
              light
              height="200"
              @click="toggle"
            >
              <v-scroll-y-transition>
                <v-list-item three-line>
                    <v-list-item-content>
                        <div class="overline mb-4">OVERLINE</div>
                        <v-list-item-title class="headline mb-1">Pending Invites</v-list-item-title>
                        <v-list-item-subtitle>{{pendinginvites}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        tile
                        size="80"
                    >
                    <v-icon>person</v-icon>
                    </v-list-item-avatar>
                    </v-list-item>

                    <v-card-actions>
                    <v-btn text>More</v-btn>
                    </v-card-actions>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-flex> -->

  
<template>
  <div>
  <v-item-group>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex
          xs12
          md4
        >
          <v-item >
            <v-card
              :color="'#fff'"
              class="d-flex align-center"
              light
              height="200"
            >
              <v-scroll-y-transition>
                <div class="display-3 flex-grow-1 text-center" >
                  <v-list-item three-line>
                    <v-list-item-content>
                        <div class="overline mb-4">OVERLINE</div>
                        <v-list-item-title class="headline mb-1">Total Members</v-list-item-title>
                        <v-list-item-subtitle>{{totalmembers}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        tile
                        size="80"
                        
                    >
                    <v-icon>people</v-icon>
                    </v-list-item-avatar>
                    </v-list-item>

                    <v-card-actions>
                    <v-btn text>More</v-btn>
                    </v-card-actions>
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-flex>


        <v-flex
          xs12
          md4
        >
          <v-item >
            <v-card
              :color="'#fff'"
              class="d-flex align-center"
              light
              height="200"
            >
              <v-scroll-y-transition>
                <div
                  class="display-3 flex-grow-1 text-center">
                  <div class="display-3 flex-grow-1 text-center" >
                  <v-list-item three-line>
                    <v-list-item-content>
                        <div class="overline mb-4">OVERLINE</div>
                        <v-list-item-title class="headline mb-1">Total Members</v-list-item-title>
                        <v-list-item-subtitle>{{totalmembers}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        tile
                        size="80"
                        
                    >
                    <v-icon>people</v-icon>
                    </v-list-item-avatar>
                    </v-list-item>

                    <v-card-actions>
                    <v-btn text>More</v-btn>
                    </v-card-actions>
                </div>
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-flex>


        <v-flex
          xs12
          md4
        >
          <v-item >
            <v-card
              :color="'#fff'"
              class="d-flex align-center"
              light
              height="200"
            >
              <v-scroll-y-transition>
                <div class="display-3 flex-grow-1 text-center">
                  <v-list-item three-line>
                    <v-list-item-content>
                        <div class="overline mb-4">OVERLINE</div>
                        <v-list-item-title class="headline mb-1">Balance</v-list-item-title>
                        <v-list-item-subtitle>{{balance}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        tile
                        size="80"
                    >
                    <v-icon>money</v-icon>
                    </v-list-item-avatar>
                    </v-list-item>

                    <v-card-actions>
                    <v-btn text>More</v-btn>
                    </v-card-actions>
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-flex>

        
      </v-layout>
    </v-container>
  </v-item-group>
</div>
</template>
<script>
  export default {
    data: () => ({
      totalmembers: 0,
      totaltasks: 0,
      pendinginvites: 0,
      balance: 0.00
    }),

    computed: {
      
    },

    watch: {
      
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        
        fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/getstats',{
                    method: 'post',
                    body: JSON.stringify({
                        phonenumber:localStorage.phonenumber,
                        groupid:localStorage.groupid
                    }),
                    headers: {
                     'content-type':'application/json'
                    }
                })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    
                    if(res.responsecode == "00")
                    {
                        console.log(res);
                        this.balance = res.balance;
                        this.pendinginvites = res.pendinginvites;
                        this.totalmembers = res.totalmembers;
                        this.totaltasks = res.totaltasks;
                        console.log(this.balance);
                        
                    }else{
                        this.$swal.fire(
                            'Errorr',
                            res.responsemessage,
                            'danger'
                        )
                    }
                    
                })
                .catch(err => console.log(err))
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>